import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        UserName: null,
        FullName: null,
        PersonCode: null,
        isAdmin: false,
        userGroups: [],
        UserBase: null,
        MustChangePasswordDate: null,

        loginVis: false,
        headerVis: true,
        IsAuthenticated: false,

        blockUICounter: 0,
        blockUIMessages: [],
        permissions: null,
        notificationUrl: null,
        notificationTargetId: null,

        navigation: [],

        onAuth: []
    },
    mutations: {
        SetGlobalData: (state, payload) => {
            state.UserName = payload.UserName;
            state.FullName = payload.FullName;
            state.PersonCode = payload.PersonCode;
            state.isAdmin = payload.isAdmin;
            state.userGroups = payload.userGroups;
            state.UserBase = payload.UserBase;
            state.MustChangePasswordDate = payload.MustChangePasswordDate;

            state.IsAuthenticated = payload.isAuthenticated;
            state.navigation = payload.navigation;
            state.permissions = payload.permissions;
            state.notificationUrl = payload.NotificationUrl;
            state.notificationTargetId = payload.NotificationTargetId;
        },
        RemoveGlobalData: (state) => {
            state.UserName = null;
            state.FullName = null;
            state.PersonCode = null;
            state.isAdmin = false;
            state.userGroups = [];
            state.UserBase = null;
            state.MustChangePasswordDate = null;

            state.IsAuthenticated = false;
            state.navigation = [];
            state.permissions = null;
            state.notificationUrl = null;
            state.notificationTargetId = null;
        },

        AddBlockUI: state => {
            state.blockUICounter++;
        },
        RemoveBlockUI: state => {
            state.blockUICounter--;
        },
        AddBlockUIMessage: (state, message) => {
            state.blockUIMessages.push(message);
        },
        RemoveBlockUIMessage: (state, removeIndex) => {
            state.blockUIMessages.splice(removeIndex, 1);
        },
        RemoveAllBlockUIMessages: state => {
            state.blockUICounter -= state.blockUIMessages.length;
            state.blockUIMessages = [];
        },
        ShowLogin: state => {
            state.loginVis = true;
        },
        HideLogin: state => {
            state.loginVis = false;
        },
        ShowHeader: state => {
            state.headerVis = true;
        },
        HideHeader: state => {
            state.headerVis = false;
        }
    },
    actions: {
        BlockUI: (context, payload) => {
            context.commit('AddBlockUI');
            if (payload) {
                context.commit('AddBlockUIMessage', payload);
            }
        },
        UnblockUI: (context, removeIndex) => {
            context.commit('RemoveBlockUI');
            if (removeIndex !== undefined) {
                context.commit('RemoveBlockUIMessage', removeIndex);
            }
        },
        CloseAllBlockUIMessages: context => {
            context.commit('RemoveAllBlockUIMessages');
        }
    },
    modules: {}
});
